// src/components/dashboard/AdminTeamTab.jsx
import React, { useState } from 'react';
import { teamService } from '../../services/api';

const initialTeamState = { name: '', position: '', description: '', active: true, image: '' };

export default function AdminTeamTab({ data: team, setData: setTeam, actionLoading, setActionLoading, setError }) {
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [currentMember, setCurrentMember] = useState(initialTeamState);

    const handleSave = async (e) => {
        e.preventDefault();
        if (actionLoading) return;
        setActionLoading(true);
        setError(null);

        try {
            let result;
            if (currentMember.id) {
                result = await teamService.updateTeamMember(currentMember.id, currentMember);
                setTeam(prev => prev.map(m => m.id === currentMember.id ? result.data || result : m));
            } else {
                result = await teamService.createTeamMember(currentMember);
                setTeam(prev => [...prev, result.data || result]);
            }
            
            setCurrentMember(initialTeamState);
            setIsFormVisible(false);
        } catch (err) {
            setError('Error al guardar el miembro del equipo.');
        } finally {
            setActionLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (actionLoading) return;
        if (!window.confirm('¿Confirmas la inactivación (eliminación) de este miembro?')) return;
        
        setActionLoading(true);
        setError(null);
        try {
            await teamService.deleteTeamMember(id); 
            setTeam(prev => prev.filter(m => m.id !== id));
        } catch (err) {
            setError('Error al inactivar el miembro.');
        } finally {
            setActionLoading(false);
        }
    };

    // Funciones de edición y nuevo (similares a AdminDistrictsTab)
    const handleEdit = (member) => { setCurrentMember(member); setIsFormVisible(true); };
    const handleNew = () => { setCurrentMember(initialTeamState); setIsFormVisible(true); };

    return (
        <div className="mt-4">
            <h4 className="text-lg font-semibold mb-3">Gestión de Equipo</h4>
            <button onClick={handleNew} className="mb-4 btn btn-green" disabled={actionLoading}>Crear Nuevo Miembro</button>

            {isFormVisible && (
                <form onSubmit={handleSave} className="mb-6 p-4 border rounded bg-gray-50 space-y-3 max-w-lg">
                    <h5 className="font-bold">{currentMember.id ? 'Editar Miembro' : 'Nuevo Miembro'}</h5>
                    
                    <input type="text" placeholder="Nombre" value={currentMember.name} onChange={(e) => setCurrentMember({ ...currentMember, name: e.target.value })} required className="input-field" disabled={actionLoading} />
                    <input type="text" placeholder="Posición / Rol" value={currentMember.position} onChange={(e) => setCurrentMember({ ...currentMember, position: e.target.value })} required className="input-field" disabled={actionLoading} />
                    <input type="text" placeholder="URL Imagen" value={currentMember.image} onChange={(e) => setCurrentMember({ ...currentMember, image: e.target.value })} className="input-field" disabled={actionLoading} />
                    <textarea placeholder="Descripción / Breve Bio" value={currentMember.description} onChange={(e) => setCurrentMember({ ...currentMember, description: e.target.value })} rows="3" className="input-field" disabled={actionLoading} />

                    <div className="flex space-x-2">
                        <button type="submit" className="btn btn-primary" disabled={actionLoading}>{actionLoading ? 'Guardando...' : 'Guardar Miembro'}</button>
                        <button type="button" onClick={() => setIsFormVisible(false)} className="btn btn-secondary" disabled={actionLoading}>Cerrar</button>
                    </div>
                </form>
            )}

            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="table-th">Nombre</th>
                            <th className="table-th">Posición</th>
                            <th className="table-th">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {team.map((m) => (
                            <tr key={m.id}>
                                <td className="table-td">{m.name}</td>
                                <td className="table-td">{m.position}</td>
                                <td className="table-td space-x-2">
                                    <button onClick={() => handleEdit(m)} className="text-[color:var(--primary)] hover:underline" disabled={actionLoading}>Editar</button>
                                    <button onClick={() => handleDelete(m.id)} className="text-red-600 hover:underline" disabled={actionLoading}>Eliminar</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}